<button mat-button color="link" (click)="showPaymentPopup()">
  <mat-icon svgIcon="action:ic_account_balance_wallet_24px" class="balance-btn__icon"></mat-icon>
  <span class="balance-btn__field">{{ balance | async | currency: 'RUB': '' }}</span>
  <span class="balance-btn__currency">{{ 'CURRENCY' | translate }}</span>
</button>
